import { array, object, string, TypeOf } from 'zod';

/* ----------------------------- SearchResponse ----------------------------- */

export const SearchResponse = object({
    data: array(string()),
});

export type SearchResponse = TypeOf<typeof SearchResponse>;
